// React
import React from "react";
import { useNavigate } from "react-router-dom";

import {
  formatLabels,
  formatCurrency,
  formatDate,
  formatAdjectives,
} from "../../../../Helpers/formatters";

// Material UI
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

// Icons
import BrandIcon from "../../../../Utilities/BrandIcon";
import CardIcon from "../../../../Utilities/CardIcon";

const OrdersBody = ({
  orders,
  order,
  orderBy,
  page,
  rowsPerPage,
  stableSort,
  getComparator,
}) => {
  const navigate = useNavigate();
  return (
    <TableBody>
      {stableSort(orders, getComparator(order, orderBy))
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map(({brand, customerName, id, campaignName, orderTotal, orderStatus, orderMessage, scn, cardType, orderDate }, index) => {
          if (brand === "Kids Live Safe") brand = "KLS";
          if (brand === "Public Data Check") brand = "PDC";
          if (brand === "SpyFly") brand = "SF";
          if (brand === "Public Info Services") brand = "PIS";
          if (brand === "Search Public Records") brand = "SPR";
          if (brand === "Public Record Reports") brand = "PRR";
          if (brand === "Quick Public Records") brand = "QPR";
          if (brand === "Property Focus") brand = "PF";

          const brandIds = {
            KLS: 1,
            SF: 2,
            PDC: 3,
            PIS: 4,
            SPR: 5,
            PRR: 6,
            QPR: 7,
            PF: 8,
          };
          
          return (
            <TableRow
              key={index}
              className="order-row"
              onClick={() => navigate(`/Customer/${id}`)}
            >
              <TableCell className="tableCell" align="center">
                {customerName}
              </TableCell>
              <TableCell className="tableCell" align="center">
                <BrandIcon brandId={brandIds[brand]} />
              </TableCell>
              <TableCell className="tableCell" align="center">
                {campaignName}
              </TableCell>
              <TableCell className="tableCell" align="center">
                {formatCurrency(orderTotal)}
              </TableCell>
              <TableCell className="tableCell" align="center">
                <span className={formatLabels(orderStatus)}>
                  {formatAdjectives(orderStatus)}
                </span>
              </TableCell>
              <TableCell className="tableCell" align="center">
                {orderMessage}
              </TableCell>
              <TableCell className="tableCell" align="center">
                {scn}
              </TableCell>
              <TableCell className="tableCell" align="center">
                <CardIcon cardType={cardType} isSmallLogo={true} />
              </TableCell>
              <TableCell className="tableCell" align="center">
                {id}
              </TableCell>
              <TableCell className="tableCell" align="center">
                {formatDate(orderDate)}
              </TableCell>
            </TableRow>
          );
        })}
    </TableBody>
  );
};

export default OrdersBody;
